// eslint-disable-next-line import/prefer-default-export
export const ordersSelector = state => state.orders.entities;
